import styled from 'styled-components';
import Slider from 'react-rangeslider';
import { focusVisibleWithOutline } from '../utils/focus-indicator';
export const StyledSlider = styled(Slider)`
  & {
    border-radius: ${({
  theme
}) => theme.extraSmallBorderRadius};
    position: relative;
    height: 4px;
    line-height: 1.625rem;
    background: ${({
  hasStep,
  theme
}) => hasStep ? 'transparent' : theme.palette.backgroundInactive};
    user-select: none;
    z-index: 2;
  }

  .rangeslider__fill {
    border-radius: ${({
  theme
}) => theme.extraSmallBorderRadius};
    display: block;
    height: 100%;
    background-color: ${props => props.theme.palette.semanticInfoStrong};
  }

  .rangeslider__handle {
    cursor: grab;
    position: absolute;
    top: -0.9rem;
    margin-left: -0.9rem;
    width: 1.8rem;
    height: 1.8rem;
    border-radius: 50%;
    background: ${props => props.theme.palette.accentSecondary1};
    box-shadow: ${props => props.theme.boxShadowMedium};
    will-change: left;
    outline: none;
    transition:
      transform 0.2s ease,
      box-shadow 0.2s ease;
    transform-origin: center;

    ${focusVisibleWithOutline({
  offset: 'default'
})}
  }

  .rangeslider__handle:active {
    cursor: grabbing;
  }

  .rangeslider__handle:active,
  .rangeslider__handle:hover {
    transform: scale(1.25);
    box-shadow: 0 0.125rem 0.5rem 0 ${props => props.theme.palette.contentDisabled};
  }
`;
export const SliderContext = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
export const SliderGrow = styled.div`
  flex-grow: 2;
  padding: 0.5rem 1rem;
`;
export const RangeIndicatorContainer = styled.div`
  position: relative;
  width: 100%;
  height: 0.25rem;
  display: flex;
  justify-content: space-between;
  top: -0.25rem;
  z-index: 1;
  background: ${props => props.theme.palette.backgroundInactive};
`;
export const RangeIndicator = styled.div`
  width: 0.25rem;
  height: 0.25rem;
  background-color: ${({
  theme
}) => theme.palette.accentSecondary1};
  border-radius: 50%;
`;
//# sourceMappingURL=styles.js.map